module.exports = __webpack_public_path__ + "static/media/back_icon.f30f7c6a.svg";